// sendCommandFlex8.js
import { nodeRedApi } from '../../services/axios';

export async function sendCommandFlex8(descricao, action) {
  console.log(`Acionado o grupo de luz ${descricao} com a ação`, action);

  const data = {
    descricao: descricao,
    modulo: action.modulo,
    action: action.status,
    idx: action.idx,
  };

  try {
    const response = await nodeRedApi.post('/comandoFlex8', data);
    console.log('Resposta do servidor:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar comando Flex8:', error);
    throw error;
  }
}